module.exports = __webpack_public_path__ + "media/MRI11C.77dbf531.mp3";